var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import LocaleHelper from '@vertical-plus/vue-js-core/dist/util/i18n/locale-helper';
export class AbstractDataTableReport {
    get widgets() {
        return [];
    }
    get filters() {
        return [];
    }
    get defaultFilters() {
        return {};
    }
    get settings() {
        return [];
    }
    get defaultSettings() {
        return {};
    }
    get columns() {
        return [];
    }
    get defaultColumns() {
        return [];
    }
    get sortBys() {
        return [];
    }
    constructor(serviceContainer) {
        this.defaultItemsPerPage = 20;
        this.defaultSortBy = '';
        this.prepared = false;
        this.serviceContainer = serviceContainer;
    }
    prepare() {
        return __awaiter(this, void 0, void 0, function* () {
            this.prepared = true;
        });
    }
    loadResults(conditions) {
        throw new Error('Method not implemented.');
    }
    downloadResults(conditions, format) {
        throw new Error('Method not implemented.');
    }
    loadSavedSearches() {
        throw new Error('Method not implemented.');
    }
    saveSearch(search) {
        throw new Error('Method not implemented.');
    }
    deleteSavedSearch(id) {
        throw new Error('Method not implemented.');
    }
    pinSavedSearch(id) {
        throw new Error('Method not implemented.');
    }
    unpinSavedSearch(id) {
        throw new Error('Method not implemented.');
    }
    saveDefaultColumns(columns, global) {
        throw new Error('Method not implemented.');
    }
    /**
     * Returns the translation for an i18n key
     *
     * @param key
     * @param params
     * @returns
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    i18n(key, params = {}) {
        return LocaleHelper.getI18n().t(key, params)
            .toString();
    }
}
//# sourceMappingURL=abstract-data-table-report.js.map